<template>
    <div
        class="card-body nch--forum-card mb-3"
        @click="topic.status ? topicSelected() : ''"
        :class="topic.status ? 'cursor-pointer' : ''"
        >
        <div class="d-flex">
            <a href="#!" class="d-none d-md-block d-md-none d-lg-block avatar avatar-lg rounded-circle mr-3 my-auto nch--avatar-min-size">
                <img v-if="topic.user.upload" alt="profile picture" :src="image(topic.user.upload)">
                <img v-else src="@img/profile.png" alt="admin profile picture">
            </a>
            <div class="my-auto">
                <h2 class="mb-0">{{topic.title}}</h2>
                <Badge v-if="!topic.status" rounded type="warning"><i class="mdi mdi-information-outline"></i> {{$t('topic.await')}}</Badge>
                <h5 v-else class="text-muted mb-0"><i class="fas fa-user-alt"></i> {{topic.user.name}}</h5>
            </div>
            <div class="d-flex ml-auto">
                <div class="d-none d-md-block d-md-none d-lg-block" style="text-align: right;">
                    <h5 class="text-muted"> {{timeFromNow}}</h5>
                    <!-- <h5 class="text-muted"><i class="far fa-eye"></i> {{topic.views}}</h5> -->
                    <h5 class="text-muted"><i class="far fa-comment-alt"></i> {{topic.answers}}</h5>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Badge from '../../argon/components/Badge'

export default {
    name: 'ForumTopic',
    components: {
        Badge,
    },
    props: {
        topic: {
            type: Object,
            required: true
        },
        loading: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            moduleName: '',
            subName: ''
        }
    },
    methods: {
        topicSelected() {
            this.$emit('topicSelected', this.topic.id)
        },

        image({
            host,
            original_file,
            urls
        }, size = 'original') {
            if (urls && urls[size]) {
                return urls[size]
            }
            return `/storage/${host}/${size}/${original_file}`
        },
    },
    computed: {
        color() {
            return this.$store.getters.COLOR
        },
        showLoading() {
            if (this.loading.status && this.loading.id === this.topic.id) return true
        },
        timeFromNow() {
            const date =  this.$moment(this.topic.created_at)
            return date.fromNow()
        }
    },
}
</script>

<style scoped>
.cursor-pointer:hover {
    cursor: pointer;
}

</style>
